"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ErrorMsg = function (_a) {
    var message = _a.message;
    return message ? (react_1.default.createElement("span", { className: "invalid-input-error-message" }, message)) : null;
};
exports.default = ErrorMsg;
